import React, { useState } from 'react';
export function RideCategoriesSection() {
  const [activeTab, setActiveTab] = useState(0);
  const categories = [{
    title: 'Special Assistance & Mobility Needs',
    description: 'Wheelchair-accessible transport with trained staff to assist patients with mobility challenges.'
  }, {
    title: 'Social & Community Events',
    description: 'Transportation to social gatherings, community events, and family functions.'
  }, {
    title: 'Healthcare Visits',
    description: 'Reliable rides to doctor appointments, dialysis, physical therapy, and hospital visits.'
  }, {
    title: 'Support & Wellness Services',
    description: 'Transport to mental health appointments, substance treatment programs, and wellness centers.'
  }, {
    title: 'Daily Living & Errands',
    description: 'Assistance with daily activities including prescription pickups, grocery shopping, and adult day care.'
  }];
  return <section className="bg-white py-20" data-id="element-219">
      <div className="max-w-7xl mx-auto px-4" data-id="element-220">
        <div className="text-center mb-12" data-id="element-221">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0B1F3A] mb-6" data-id="element-222">
            Categories of Rides We Offer
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-223">
            Comprehensive transportation solutions for all your medical and
            daily needs
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-224">
          {/* Tabs */}
          <div className="lg:col-span-2" data-id="element-225">
            <div className="flex flex-wrap gap-2 mb-6" data-id="element-226">
              {categories.map((category, index) => <button key={index} onClick={() => setActiveTab(index)} className={`px-4 py-2 rounded-md font-semibold transition-all ${activeTab === index ? 'bg-[#E63946] text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-227">
                  {category.title}
                </button>)}
            </div>

            {/* Content */}
            <div className="bg-[#F5F5F5] rounded-lg p-8" data-id="element-228">
              <h3 className="text-2xl font-bold text-[#0B1F3A] mb-4" data-id="element-229">
                {categories[activeTab].title}
              </h3>
              <p className="text-gray-700 text-lg" data-id="element-230">
                {categories[activeTab].description}
              </p>
            </div>
          </div>

          {/* Map Illustration */}
          <div className="bg-[#F5F5F5] rounded-lg p-8 flex items-center justify-center" data-id="element-231">
            <div className="text-center" data-id="element-232">
              <div className="w-48 h-48 bg-[#0B1F3A] bg-opacity-10 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-233">
                <span className="text-6xl" data-id="element-234">🗺️</span>
              </div>
              <p className="text-gray-700 font-semibold" data-id="element-235">
                Service Area Coverage
              </p>
              <p className="text-gray-600 text-sm mt-2" data-id="element-236">
                Upper Marlboro & Surrounding Areas
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}